import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { NgFor, NgIf } from '@angular/common';
import { environment } from 'src/environments/environment.prod';

@Component({
  selector: 'app-product-color-size',
  templateUrl: './product-color-size.component.html',
  styleUrls: ['./product-color-size.component.scss'],
  standalone: true,
  imports: [NgFor, NgIf]
})
export class ProductColorSizeComponent implements OnChanges {
  cdnImagePath = environment.cdnImagePath;
  uniqueColors: any[] = [];
  uniqueSizes: any[] = [];

  @Input() productColor: any[] = [];
  @Input() productSize: any[] = [];
  @Input() selectedColorKey: number | null = null;
  @Input() selectedSizeKey: number | null = null;
  @Input() availableColors: number[] = [];
  @Input() availableSizes: number[] = [];

  @Output() colorChange = new EventEmitter<number | null>();
  @Output() sizeChange = new EventEmitter<number | null>();

  ngOnChanges(): void {
    this.uniqueColors = this.getUnique(this.productColor, 'color_key');
    this.uniqueSizes = this.getUnique(this.productSize, 'size_key');
  }

  selectColor(color: any) {
    if(this.uniqueColors?.length === 1) return;
    if (!this.availableColors.includes(color.color_key)) {
      // tell parent: fresh start with this color
      this.colorChange.emit(-color.color_key); // NEGATIVE = reset + select
      return;
    }
    this.colorChange.emit(color.color_key);
  }

  selectSize(size: any) {
    if(this.uniqueSizes?.length === 1) return;
    if (!this.availableSizes.includes(size.size_key)) {
      // tell parent: fresh start with this size
      this.sizeChange.emit(-size.size_key); // NEGATIVE = reset + select
      return;
    }
    this.sizeChange.emit(size.size_key);
  }

  private getUnique(list: any[], key: string) {
    const map = new Map();
    list.forEach(item => map.set(item[key], item));
    return Array.from(map.values());
  }
}